import 'intersection-observer';

// Expand this functionality if needed
export const observe = (
  callback: IntersectionObserverCallback,
  options?: IntersectionObserverInit
): IntersectionObserver => {
  return new IntersectionObserver(callback, options);
};
